import { Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import IconSpinner from '../../img/spinner.gif';
import closeBtnImg from '../../img/dlg-close.png';
import IconFail from '../../img/ico_error.png';
import {
  hideNaverWorksPopup,
  useNaverWorksPopupDataSliceSelector
} from '../../store/modules/naverWorksPopupData';
import Blanket from '../common/Blanket';

const ProgressWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 10px 12px 30px 12px;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 2px;
  /* display: flex; */
  border: 1px solid #b1b6bb;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  /* padding: 1rem; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 322px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 280px;
    `}
`;
const ContentsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const DocOpenProgressImg = styled.img`
  width: 64px;
  height: 64px;
`;

const PopupMessage = styled.span`
  margin-top: 11px;
  font-size: 14px;
  text-align: center;
  color: #2f3133;
`;

const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 24px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 12px;
`;

const CloseBtn = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export default function NaverWorksProcessPopup() {
  const naverWorksPopupSlice = useNaverWorksPopupDataSliceSelector();
  const dispatch = useDispatch();
  const onClickClose = () => {
    dispatch(hideNaverWorksPopup());
  };

  if (!naverWorksPopupSlice.isShow) return null;

  return (
    <>
      <Blanket />
      <ProgressWrapper isMobile={naverWorksPopupSlice.isMobile}>
        <TitleWrapper>
          {naverWorksPopupSlice.isError && (
            <CloseBtn onClick={onClickClose}>
              <img src={closeBtnImg} alt="Close Button"></img>
            </CloseBtn>
          )}
        </TitleWrapper>
        <ContentsWrapper>
          <DocOpenProgressImg
            src={naverWorksPopupSlice.isError ? IconFail : IconSpinner}
            isMobile={naverWorksPopupSlice.isMobile}
          />
          <PopupMessage>
            <Trans i18nKey={naverWorksPopupSlice.messageKey} />
            {naverWorksPopupSlice.errorCode && `( ${naverWorksPopupSlice.errorCode} )`}
          </PopupMessage>
        </ContentsWrapper>
      </ProgressWrapper>
    </>
  );
}
